<script setup lang="ts">
import type { ComboboxContentProps } from "./combobox.types";
import { useComboboxContent } from "./useCombobox.Content";
import { DEFAULT_POSITIONING } from "composables/usePosition";

defineOptions({ name: "ComboboxContent" });

const props = withDefaults(defineProps<ComboboxContentProps>(), {
  placement: DEFAULT_POSITIONING.placement,
  offset: DEFAULT_POSITIONING.offset,
  maxHeight: "300px",
});

const { inputId, listboxStyle, positioning, combobox, handleFloatingClose, handleFloatingOpen } = useComboboxContent({
  props,
});
</script>

<template>
  <e-floating
    class="e-combobox-content"
    :trigger="`#${inputId}`"
    :placement="positioning.placement"
    :offset="positioning.offset"
    :boundary-margin="positioning.boundaryMargin"
    :collision-strategy="positioning.collisionStrategy"
    :open="combobox.isOpen.value"
    close-on-click-outside
    rendering-strategy="absolute"
    trigger-mode="manual"
    eager
    @close="handleFloatingClose"
    @open="handleFloatingOpen"
  >
    <e-listbox
      :class="$attrs.class"
      :style="listboxStyle"
      :color="combobox.comboboxProps.value?.color"
      :variant="combobox.comboboxProps.value?.variant"
      size="xs"
      :multiple="combobox.comboboxProps.value?.multiple"
      :disabled="combobox.comboboxProps.value?.disabled"
      :model-value="combobox.modelValue.value"
      :highlighted-value="combobox.highlightedValue.value"
      selection-behavior="replace"
      prevent-page-scroll
      @mousedown.prevent
    >
      <slot />
    </e-listbox>
  </e-floating>
</template>

<style>
:host {
  display: contents;
}
</style>
